module.exports = __webpack_public_path__ + "send-fb.2bf8c230.jpg";